<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form class="h-full flex flex-col">
			<!-- header title -->
			<div class="bg-green-500 px-6 py-4 text-white">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold">
						<span v-if="locale == 'de'"
							>Wir möchten Sie bestmöglich informieren!</span
						>
						<span v-else>We would like to inform you as best we can!</span>
					</h1>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<div class="min-h-[30rem] flex flex-col">
				<ui-alert-errors
					v-if="otherErrorMessages.length > 0"
					:messages="otherErrorMessages"
					class="border-b border-red-300 rounded-none"
				/>

				<div class>
					<div
						class="bg-gray-100 px-6 py-4 text-gray-500 sm:flex sm:items-end sm:justify-between sm:space-x-4"
					>
						<p v-if="locale == 'de'">
							Bitte wählen Sie Ihre bevorzugten Produkte aus und erhalten sie
							nur dann Ihre persönlichen Ab-Hof-Preise, individuelle
							Marktinformationen und maßgeschneiderte Analysen.
						</p>
						<p v-else>
							Please add your favorite products to receive personalized farm
							gate prices, individual market information and analytics.
						</p>
					</div>
					<user-edit-my-products
						:user="user"
						:form="form"
						:has-h1="false"
						:default-products="['WHEAT', 'RAPE', 'BARLEY']"
					/>
				</div>
			</div>

			<!-- button footer -->
			<div class="bg-gray-100 p-6 flex justify-between items-center">
				<div />
				<div>
					<ui-button
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		user: {
			type: Object,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.user)),
		};
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
	},
};
</script>
